import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    marginLeft: 15,
    marginRight: 10,
    fontSize: 15,
    color: theme.custom.darkBlue,
  },
}));
